<!-- <div class="card" *ngIf="!chnage_request && !is_reject_vendor">
    <h1 class="fontsizeSet">your registration request is successfully submitted, and is under review from Rockman Team!</h1>
    <h3>If you have any queries, contact us on info&#64;rockman.in .</h3>
</div>
<div class="card" *ngIf="chnage_request">
    <h1 class="fontsizeSet">your request is successfully submitted, and is under review from Rockman Team!</h1>
    <h3>If you have any queries, contact us on info&#64;rockman.in .</h3>
</div>
<div class="card" *ngIf="is_reject_vendor">
    <h1 class="fontsizeSet">your request is rejected by Rockman Team!</h1>
    <h3>If you have any queries, contact us on info&#64;rockman.in .</h3>
</div> -->
<div class="card">
  <h1 class="fontsizeSet">{{status}}</h1>
  <h3>If you have any queries, contact us on info&#64;rockman.in .</h3>
</div>
